import * as React from 'react';
import { useSelector } from 'react-redux';

import { SeoTabsLinks } from '../../components/SeoTabsLinks';
import { selectSeoTabsLinks } from '../../selectors/seoTabsLinks';

interface ISeoTabsLinksContainerProps {
  className?: string;
}

export const SeoTabsLinksContainer = ({ className }: ISeoTabsLinksContainerProps) => {
  const tabs = useSelector(selectSeoTabsLinks);

  if (tabs.length === 0) {
    return null;
  }

  return <SeoTabsLinks className={className} tabs={tabs} />;
};
